// extracted by mini-css-extract-plugin
module.exports = {"tabActions":"style-module__tabActions___fORYW","end":"style-module__end___17MP2","spaced":"style-module__spaced___3U890"};